export const AUDIO_DOWNLOAD_TYPE = 'AUDIO_DOWNLOAD_TYPE';

export class LocalStorageService {
  constructor() {
  }

  getItem(key, value) {
    return localStorage && localStorage.getItem(key);
  }

  setItem(key, value) {
    return localStorage && localStorage.setItem(key, value);
  }

  removeItem(key, value) {
    return localStorage && localStorage.removeItem(key);
  }
}



// WEBPACK FOOTER //
// ./src/core/local-storage.service.js